
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91commissionId_93mqxyvH01vCMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/commissions/[commissionId].vue?macro=true";
import { default as indexSPE5Xh8HkXMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/commissions/index.vue?macro=true";
import { default as entitieswcAgTSW0paMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/entities.vue?macro=true";
import { default as networkU8NDUenZKLMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/network.vue?macro=true";
import { default as profileRdlJFzA9pxMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/profile.vue?macro=true";
import { default as _91slipId_93sdc8UdKPcvMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/slips/[slipId].vue?macro=true";
import { default as indexsjG0Sx48nYMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/slips/index.vue?macro=true";
import { default as _91caseId_93dJaUTcUA6VMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/cases/[caseId].vue?macro=true";
import { default as indexqVXVv1uafLMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/cases/index.vue?macro=true";
import { default as _91commissionId_93sVlBZRLklGMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/commissions/[commissionId].vue?macro=true";
import { default as indexAr3dhTgtBJMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/commissions/index.vue?macro=true";
import { default as create_45memberhvH9PAuD1HMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/create-member.vue?macro=true";
import { default as entity2f27RyjMceMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/entity.vue?macro=true";
import { default as indextIe2X0fGIWMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/index.vue?macro=true";
import { default as membersDWifM0kx78Meta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/members.vue?macro=true";
import { default as slips3qNWZLGMy0Meta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/slips.vue?macro=true";
import { default as _91entityId_93hO2t4QowPzMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId].vue?macro=true";
import { default as indexBJqT2IKw4fMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/index.vue?macro=true";
import { default as coachufgl4AHmKSMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/coach.vue?macro=true";
import { default as _91commissionId_9336vir2IIwjMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/commissions/[commissionId].vue?macro=true";
import { default as indexoKGiicHPU4Meta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/commissions/index.vue?macro=true";
import { default as entitiesL9WiAOkbGHMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/entities.vue?macro=true";
import { default as generalpv1FsB84FWMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/general.vue?macro=true";
import { default as indexUJ9xCVFFjdMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/index.vue?macro=true";
import { default as networkkUSju8HUIZMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/network.vue?macro=true";
import { default as referrerjwUaXsZ1IjMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/referrer.vue?macro=true";
import { default as _91memberUid_93oF1f0okLPRMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid].vue?macro=true";
import { default as indexD9cGhP2SVXMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/index.vue?macro=true";
import { default as _91slipId_93F1DUBOpJyPMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/slips/[slipId].vue?macro=true";
import { default as indexsZD9j2kVsPMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/slips/index.vue?macro=true";
import { default as indexFli2tJlxeHMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/index.vue?macro=true";
import { default as mlm_45parametersN7TmBG1c04Meta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/mlm-parameters.vue?macro=true";
import { default as organizationsfvPCbdU3T7Meta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/admin/organizations.vue?macro=true";
import { default as users_45batchnM7F4jueapMeta } from "/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/users-batch.vue?macro=true";
import { default as usersTWY9HbpUzrMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/admin/users.vue?macro=true";
import { default as loginRbA3vlugfLMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/auth/login.vue?macro=true";
import { default as reset_45passwordNF63cuumvjMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/auth/reset-password.vue?macro=true";
import { default as sign_45upjnPoKxnj36Meta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/auth/sign-up.vue?macro=true";
import { default as indexEo7bdcXsxsMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/index.vue?macro=true";
import { default as createnNluKbyL5aMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/organization/create.vue?macro=true";
import { default as invitationsMwtkM45VdGMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/organization/invitations.vue?macro=true";
import { default as _91token_93ybTrmFbrHMMeta } from "/Users/erwannletue/Dev/dearfox/genesis/pages/process/organization-invitation/[organizationId]/[token].vue?macro=true";
export default [
  {
    name: "organizationURLPath-account-commissions-commissionId___fr",
    path: "/:organizationURLPath()/account/commissions/:commissionId()",
    meta: _91commissionId_93mqxyvH01vCMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/commissions/[commissionId].vue")
  },
  {
    name: "organizationURLPath-account-commissions-commissionId___en",
    path: "/en/:organizationURLPath()/account/commissions/:commissionId()",
    meta: _91commissionId_93mqxyvH01vCMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/commissions/[commissionId].vue")
  },
  {
    name: "organizationURLPath-account-commissions___fr",
    path: "/:organizationURLPath()/account/commissions",
    meta: indexSPE5Xh8HkXMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/commissions/index.vue")
  },
  {
    name: "organizationURLPath-account-commissions___en",
    path: "/en/:organizationURLPath()/account/commissions",
    meta: indexSPE5Xh8HkXMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/commissions/index.vue")
  },
  {
    name: "organizationURLPath-account-entities___fr",
    path: "/:organizationURLPath()/account/entities",
    meta: entitieswcAgTSW0paMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/entities.vue")
  },
  {
    name: "organizationURLPath-account-entities___en",
    path: "/en/:organizationURLPath()/account/entities",
    meta: entitieswcAgTSW0paMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/entities.vue")
  },
  {
    name: "organizationURLPath-account-network___fr",
    path: "/:organizationURLPath()/account/network",
    meta: networkU8NDUenZKLMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/network.vue")
  },
  {
    name: "organizationURLPath-account-network___en",
    path: "/en/:organizationURLPath()/account/network",
    meta: networkU8NDUenZKLMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/network.vue")
  },
  {
    name: "organizationURLPath-account-profile___fr",
    path: "/:organizationURLPath()/account/profile",
    meta: profileRdlJFzA9pxMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/profile.vue")
  },
  {
    name: "organizationURLPath-account-profile___en",
    path: "/en/:organizationURLPath()/account/profile",
    meta: profileRdlJFzA9pxMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/profile.vue")
  },
  {
    name: "organizationURLPath-account-slips-slipId___fr",
    path: "/:organizationURLPath()/account/slips/:slipId()",
    meta: _91slipId_93sdc8UdKPcvMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/slips/[slipId].vue")
  },
  {
    name: "organizationURLPath-account-slips-slipId___en",
    path: "/en/:organizationURLPath()/account/slips/:slipId()",
    meta: _91slipId_93sdc8UdKPcvMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/slips/[slipId].vue")
  },
  {
    name: "organizationURLPath-account-slips___fr",
    path: "/:organizationURLPath()/account/slips",
    meta: indexsjG0Sx48nYMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/slips/index.vue")
  },
  {
    name: "organizationURLPath-account-slips___en",
    path: "/en/:organizationURLPath()/account/slips",
    meta: indexsjG0Sx48nYMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/account/slips/index.vue")
  },
  {
    name: "organizationURLPath-corporate-cases-caseId___fr",
    path: "/:organizationURLPath()/corporate/cases/:caseId()",
    meta: _91caseId_93dJaUTcUA6VMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/cases/[caseId].vue")
  },
  {
    name: "organizationURLPath-corporate-cases-caseId___en",
    path: "/en/:organizationURLPath()/corporate/cases/:caseId()",
    meta: _91caseId_93dJaUTcUA6VMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/cases/[caseId].vue")
  },
  {
    name: "organizationURLPath-corporate-cases___fr",
    path: "/:organizationURLPath()/corporate/cases",
    meta: indexqVXVv1uafLMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/cases/index.vue")
  },
  {
    name: "organizationURLPath-corporate-cases___en",
    path: "/en/:organizationURLPath()/corporate/cases",
    meta: indexqVXVv1uafLMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/cases/index.vue")
  },
  {
    name: "organizationURLPath-corporate-commissions-commissionId___fr",
    path: "/:organizationURLPath()/corporate/commissions/:commissionId()",
    meta: _91commissionId_93sVlBZRLklGMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/commissions/[commissionId].vue")
  },
  {
    name: "organizationURLPath-corporate-commissions-commissionId___en",
    path: "/en/:organizationURLPath()/corporate/commissions/:commissionId()",
    meta: _91commissionId_93sVlBZRLklGMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/commissions/[commissionId].vue")
  },
  {
    name: "organizationURLPath-corporate-commissions___fr",
    path: "/:organizationURLPath()/corporate/commissions",
    meta: indexAr3dhTgtBJMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/commissions/index.vue")
  },
  {
    name: "organizationURLPath-corporate-commissions___en",
    path: "/en/:organizationURLPath()/corporate/commissions",
    meta: indexAr3dhTgtBJMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/commissions/index.vue")
  },
  {
    name: "organizationURLPath-corporate-create-member___fr",
    path: "/:organizationURLPath()/corporate/create-member",
    meta: create_45memberhvH9PAuD1HMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/create-member.vue")
  },
  {
    name: "organizationURLPath-corporate-create-member___en",
    path: "/en/:organizationURLPath()/corporate/create-member",
    meta: create_45memberhvH9PAuD1HMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/create-member.vue")
  },
  {
    name: _91entityId_93hO2t4QowPzMeta?.name,
    path: "/:organizationURLPath()/corporate/entities/:entityId()",
    meta: _91entityId_93hO2t4QowPzMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId].vue"),
    children: [
  {
    name: "organizationURLPath-corporate-entities-entityId-entity___fr",
    path: "entity",
    meta: entity2f27RyjMceMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/entity.vue")
  },
  {
    name: "organizationURLPath-corporate-entities-entityId___fr",
    path: "",
    meta: indextIe2X0fGIWMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/index.vue")
  },
  {
    name: "organizationURLPath-corporate-entities-entityId-members___fr",
    path: "members",
    meta: membersDWifM0kx78Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/members.vue")
  },
  {
    name: "organizationURLPath-corporate-entities-entityId-slips___fr",
    path: "slips",
    meta: slips3qNWZLGMy0Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/slips.vue")
  }
]
  },
  {
    name: _91entityId_93hO2t4QowPzMeta?.name,
    path: "/en/:organizationURLPath()/corporate/entities/:entityId()",
    meta: _91entityId_93hO2t4QowPzMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId].vue"),
    children: [
  {
    name: "organizationURLPath-corporate-entities-entityId-entity___en",
    path: "entity",
    meta: entity2f27RyjMceMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/entity.vue")
  },
  {
    name: "organizationURLPath-corporate-entities-entityId___en",
    path: "",
    meta: indextIe2X0fGIWMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/index.vue")
  },
  {
    name: "organizationURLPath-corporate-entities-entityId-members___en",
    path: "members",
    meta: membersDWifM0kx78Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/members.vue")
  },
  {
    name: "organizationURLPath-corporate-entities-entityId-slips___en",
    path: "slips",
    meta: slips3qNWZLGMy0Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/[entityId]/slips.vue")
  }
]
  },
  {
    name: "organizationURLPath-corporate-entities___fr",
    path: "/:organizationURLPath()/corporate/entities",
    meta: indexBJqT2IKw4fMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/index.vue")
  },
  {
    name: "organizationURLPath-corporate-entities___en",
    path: "/en/:organizationURLPath()/corporate/entities",
    meta: indexBJqT2IKw4fMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/entities/index.vue")
  },
  {
    name: _91memberUid_93oF1f0okLPRMeta?.name,
    path: "/:organizationURLPath()/corporate/members/:memberUid()",
    meta: _91memberUid_93oF1f0okLPRMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid].vue"),
    children: [
  {
    name: "organizationURLPath-corporate-members-memberUid-coach___fr",
    path: "coach",
    meta: coachufgl4AHmKSMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/coach.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-commissions-commissionId___fr",
    path: "commissions/:commissionId()",
    meta: _91commissionId_9336vir2IIwjMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/commissions/[commissionId].vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-commissions___fr",
    path: "commissions",
    meta: indexoKGiicHPU4Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/commissions/index.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-entities___fr",
    path: "entities",
    meta: entitiesL9WiAOkbGHMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/entities.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-general___fr",
    path: "general",
    meta: generalpv1FsB84FWMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/general.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid___fr",
    path: "",
    meta: indexUJ9xCVFFjdMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/index.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-network___fr",
    path: "network",
    meta: networkkUSju8HUIZMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/network.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-referrer___fr",
    path: "referrer",
    meta: referrerjwUaXsZ1IjMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/referrer.vue")
  }
]
  },
  {
    name: _91memberUid_93oF1f0okLPRMeta?.name,
    path: "/en/:organizationURLPath()/corporate/members/:memberUid()",
    meta: _91memberUid_93oF1f0okLPRMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid].vue"),
    children: [
  {
    name: "organizationURLPath-corporate-members-memberUid-coach___en",
    path: "coach",
    meta: coachufgl4AHmKSMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/coach.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-commissions-commissionId___en",
    path: "commissions/:commissionId()",
    meta: _91commissionId_9336vir2IIwjMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/commissions/[commissionId].vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-commissions___en",
    path: "commissions",
    meta: indexoKGiicHPU4Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/commissions/index.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-entities___en",
    path: "entities",
    meta: entitiesL9WiAOkbGHMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/entities.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-general___en",
    path: "general",
    meta: generalpv1FsB84FWMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/general.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid___en",
    path: "",
    meta: indexUJ9xCVFFjdMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/index.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-network___en",
    path: "network",
    meta: networkkUSju8HUIZMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/network.vue")
  },
  {
    name: "organizationURLPath-corporate-members-memberUid-referrer___en",
    path: "referrer",
    meta: referrerjwUaXsZ1IjMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/[memberUid]/referrer.vue")
  }
]
  },
  {
    name: "organizationURLPath-corporate-members___fr",
    path: "/:organizationURLPath()/corporate/members",
    meta: indexD9cGhP2SVXMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/index.vue")
  },
  {
    name: "organizationURLPath-corporate-members___en",
    path: "/en/:organizationURLPath()/corporate/members",
    meta: indexD9cGhP2SVXMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/members/index.vue")
  },
  {
    name: "organizationURLPath-corporate-slips-slipId___fr",
    path: "/:organizationURLPath()/corporate/slips/:slipId()",
    meta: _91slipId_93F1DUBOpJyPMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/slips/[slipId].vue")
  },
  {
    name: "organizationURLPath-corporate-slips-slipId___en",
    path: "/en/:organizationURLPath()/corporate/slips/:slipId()",
    meta: _91slipId_93F1DUBOpJyPMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/slips/[slipId].vue")
  },
  {
    name: "organizationURLPath-corporate-slips___fr",
    path: "/:organizationURLPath()/corporate/slips",
    meta: indexsZD9j2kVsPMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/slips/index.vue")
  },
  {
    name: "organizationURLPath-corporate-slips___en",
    path: "/en/:organizationURLPath()/corporate/slips",
    meta: indexsZD9j2kVsPMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/corporate/slips/index.vue")
  },
  {
    name: "organizationURLPath___fr",
    path: "/:organizationURLPath()",
    meta: indexFli2tJlxeHMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/index.vue")
  },
  {
    name: "organizationURLPath___en",
    path: "/en/:organizationURLPath()",
    meta: indexFli2tJlxeHMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/[organizationURLPath]/index.vue")
  },
  {
    name: "admin-mlm-parameters___fr",
    path: "/admin/mlm-parameters",
    meta: mlm_45parametersN7TmBG1c04Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/mlm-parameters.vue")
  },
  {
    name: "admin-mlm-parameters___en",
    path: "/en/admin/mlm-parameters",
    meta: mlm_45parametersN7TmBG1c04Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/mlm-parameters.vue")
  },
  {
    name: "admin-organizations___fr",
    path: "/admin/organizations",
    meta: organizationsfvPCbdU3T7Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/admin/organizations.vue")
  },
  {
    name: "admin-organizations___en",
    path: "/en/admin/organizations",
    meta: organizationsfvPCbdU3T7Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/admin/organizations.vue")
  },
  {
    name: "admin-users-batch___fr",
    path: "/admin/users-batch",
    meta: users_45batchnM7F4jueapMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/users-batch.vue")
  },
  {
    name: "admin-users-batch___en",
    path: "/en/admin/users-batch",
    meta: users_45batchnM7F4jueapMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/courtinet/pages/admin/users-batch.vue")
  },
  {
    name: "admin-users___fr",
    path: "/admin/users",
    meta: usersTWY9HbpUzrMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/admin/users.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersTWY9HbpUzrMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/admin/users.vue")
  },
  {
    name: "auth-login___fr",
    path: "/auth/login",
    meta: loginRbA3vlugfLMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/login.vue")
  },
  {
    name: "auth-login___en",
    path: "/en/auth/login",
    meta: loginRbA3vlugfLMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/login.vue")
  },
  {
    name: "auth-reset-password___fr",
    path: "/auth/reset-password",
    meta: reset_45passwordNF63cuumvjMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___en",
    path: "/en/auth/reset-password",
    meta: reset_45passwordNF63cuumvjMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/reset-password.vue")
  },
  {
    name: "auth-sign-up___fr",
    path: "/auth/sign-up",
    meta: sign_45upjnPoKxnj36Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/sign-up.vue")
  },
  {
    name: "auth-sign-up___en",
    path: "/en/auth/sign-up",
    meta: sign_45upjnPoKxnj36Meta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/auth/sign-up.vue")
  },
  {
    name: "index___fr",
    path: "/",
    meta: indexEo7bdcXsxsMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexEo7bdcXsxsMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/index.vue")
  },
  {
    name: "organization-create___fr",
    path: "/organization/create",
    meta: createnNluKbyL5aMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/organization/create.vue")
  },
  {
    name: "organization-create___en",
    path: "/en/organization/create",
    meta: createnNluKbyL5aMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/organization/create.vue")
  },
  {
    name: "organization-invitations___fr",
    path: "/organization/invitations",
    meta: invitationsMwtkM45VdGMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/organization/invitations.vue")
  },
  {
    name: "organization-invitations___en",
    path: "/en/organization/invitations",
    meta: invitationsMwtkM45VdGMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/organization/invitations.vue")
  },
  {
    name: "process-organization-invitation-organizationId-token___fr",
    path: "/process/organization-invitation/:organizationId()/:token()",
    meta: _91token_93ybTrmFbrHMMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/process/organization-invitation/[organizationId]/[token].vue")
  },
  {
    name: "process-organization-invitation-organizationId-token___en",
    path: "/en/process/organization-invitation/:organizationId()/:token()",
    meta: _91token_93ybTrmFbrHMMeta || {},
    component: () => import("/Users/erwannletue/Dev/dearfox/genesis/pages/process/organization-invitation/[organizationId]/[token].vue")
  }
]